import { Text } from "@/components/ui/text";

import { useInputRadio, UseInputRadioProps } from "./use-input-radio";

export type InputRadioProps = UseInputRadioProps;

function InputRadio(props: InputRadioProps) {
  const { className, styles, componentProps, id, label } = useInputRadio(props);

  return (
    <div className={styles.base({ className })}>
      <div className={styles.inputWrapper()}>
        <input {...componentProps} type="radio" className={styles.input()} id={id} />
        <span className={styles.radio()} />
      </div>
      {label && (
        <Text tag="label" htmlFor={id} size="bodyMedium" className={styles.label()}>
          {label}
        </Text>
      )}
    </div>
  );
}

export default InputRadio;
